'use client'

import { useState } from 'react'
import { Spacer, Button, Cell, Text } from '@vinted/web-ui'

import { INBOX_URL } from '@marketplace-web/domain/conversation-messaging-data'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useBreakpoint } from '@marketplace-web/shared/breakpoints'
import { navigateToPage, reloadPage } from '@marketplace-web/shared/browser'
import UserBlockModal from 'components/UserBlockModal'
import { useSession } from '@marketplace-web/shared/session'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'

import DeleteConversationModal from '../DeleteConversationModal'

type Props = {
  userLogin: string
  oppositeUserId: string
}

const BlockedUserInfoMessage = ({ userLogin, oppositeUserId }: Props) => {
  const translate = useTranslate('conversation.blocked_user_info')
  const [isUnblockModalVisible, setIsUnblockModalVisible] = useState(false)
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const conversationId = useConversationContext().conversation?.id
  const currentUserId = useSession().user?.id
  const breakpoints = useBreakpoint()

  const handleUnblockConfirm = () => {
    setIsUnblockModalVisible(false)
    reloadPage()
  }

  const handleToggleUnblockModal = () => {
    setIsUnblockModalVisible(!isUnblockModalVisible)
  }

  const handleToggleDeleteModal = () => {
    setIsDeleteModalVisible(!isDeleteModalVisible)
  }

  const handleDeleteConfirm = () => {
    setIsDeleteModalVisible(false)
    navigateToPage(INBOX_URL)
  }

  if (!conversationId || !currentUserId) return null

  return (
    <>
      <Cell
        title={translate('title')}
        body={
          <>
            <Text as="span" text={translate('body')} />
            <Spacer size={Spacer.Size.Large} />
            <Button
              styling={Button.Styling.Filled}
              text={translate('actions.unblock')}
              onClick={handleToggleUnblockModal}
              inline={!breakpoints.phones}
              testId="blocked-user-action-unblock"
            />
            <Spacer
              orientation={
                breakpoints.phones ? Spacer.Orientation.Horizontal : Spacer.Orientation.Vertical
              }
              size={Spacer.Size.Large}
            />
            <Button
              text={translate('actions.delete_conversation')}
              theme="warning"
              onClick={handleToggleDeleteModal}
              inline={!breakpoints.phones}
              testId="blocked-user-action-delete-conversation"
            />
          </>
        }
      />
      <UserBlockModal
        username={userLogin}
        isUserBlocked
        userId={Number(oppositeUserId)}
        isVisible={isUnblockModalVisible}
        onCancel={handleToggleUnblockModal}
        onConfirm={handleUnblockConfirm}
      />
      <DeleteConversationModal
        conversationId={conversationId}
        show={isDeleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={handleToggleDeleteModal}
      />
    </>
  )
}

export default BlockedUserInfoMessage
